import React from 'react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';
const groups = [{
  title: 'Get in the room',
  line: 'Podcasts, interviews, speaking and content.'
}, {
  title: 'Continue the conversation',
  line: 'Follow-up, clearer calls to action and stronger sales conversations.'
}, {
  title: 'Connect people to the right work',
  line: 'Coaching · Consulting · Speaking · Training · Workshops · Courses · Certification · Advisory · Community · Team implementation',
  emphasize: true
}];

/**
 * Simplified editorial business-payoff — three forms of author leverage.
 * Resting state is fully opaque for contrast (no faded/disabled look).
 */
export function BusinessPayoffV2() {
  return <section className="bg-[#1a2838] px-6 pb-12 pt-10 text-[#faf8f5] md:px-10 md:pb-14 md:pt-12" data-id="element-645" data-mp="1le9pqudnj4iu">
      <div className="mx-auto max-w-5xl" data-id="element-646" data-mp="e06ma77fti17">
        <div className="max-w-3xl" data-id="element-647" data-mp="dxtw56rj01d2">
          <Reveal data-id="element-648" data-mp="9yl6aczlwnms">
            <Eyebrow data-id="element-649" data-mp="9xa066iov3si">Author leverage</Eyebrow>
            <h2 className="mt-3 font-serif text-3xl leading-[1.08] text-[#faf8f5] md:text-5xl" data-id="element-650" data-mp="a0fr7ravofqv">
              The book keeps working
              <br data-id="element-651" data-mp="2kmfj62t5osf1" />
              <span className="italic text-[#a8c4bb]" data-id="element-652" data-mp="2kkuma6jdcxe0">inside the business.</span>
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-[#faf8f5]/95" data-id="element-653" data-mp="26l32fp668ms3">
              The same ideas help you get in the room, continue the conversation,
              and connect people to the right work.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.05} data-id="element-654" data-mp="1wui9ah99oagk">
          <div className="mt-10 divide-y divide-white/15 border-y border-white/15" data-id="element-655" data-mp="21nbboyh9j6ph">
            {groups.map(g => <div key={g.title} className={`py-5 md:grid md:grid-cols-[minmax(0,16rem)_1fr] md:items-baseline md:gap-10 md:py-6 ${g.emphasize ? 'md:py-7' : ''}`} data-id="element-656" data-mp="1myx09z5s69xb">
                <h3 className={`font-serif leading-snug ${g.emphasize ? 'text-2xl text-[#d4a574] md:text-3xl' : 'text-xl text-[#faf8f5] md:text-2xl'}`} data-id="element-657" data-mp="1dxgzmj4rpm6a">
                  {g.title}
                </h3>
                <p className="mt-2 text-base leading-relaxed text-[#faf8f5]/95 md:mt-0 md:text-lg" data-id="element-658" data-mp="3klpo5wttb5yo">
                  {g.line}
                </p>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-659" data-mp="3avwex2h572xl">
          <p className="mx-auto mt-10 max-w-3xl text-center font-serif text-2xl leading-snug text-[#faf8f5] md:text-3xl" data-id="element-660" data-mp="3av4veq0tkvno">
            That is the opportunity.
            <br data-id="element-661" data-mp="36shyiapakkjm" />
            <span className="italic text-[#a8c4bb]" data-id="element-662" data-mp="7exoman3yiao">
              But it is probably not what is happening now.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}